/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_appsync_graphqlEndpoint": "https://wfhi6drspfey5klcz56slpifbu.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-west-2:a8e4d3fe-448d-4089-8c5a-38f768a8037e",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_0XYUkgxZO",
    "aws_user_pools_web_client_id": "jnvq6p5b06emo2qniujti9ptv",
    "oauth": {
        "domain": "ngpsselfserviceauth.auth.eu-west-2.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_user_files_s3_bucket": "cex-ngps-private-bucket-uat",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
